import { tv } from '~/utils/tv'

export const SearchBarContainer = tv({
  base: `
    group flex items-center justify-between rounded-pill min-w-[11.25rem] w-full gap-onepulse pl-threepulse pr-onepulse relative py-[0.125rem]
    text-text-neutral leading-none border-solid bg-forms-fill border-forms-fill duration-100 ease-in
    [&:not(:focus-within)]:has-[:placeholder-shown]:border-forms-border
    hover:[&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill-hovered
    hover:[&:not(:focus-within)]:has-[:placeholder-shown]:border-forms-border-hovered
    focus:border-forms-border-focused focus:bg-forms-fill-focused focus:border-halfpulse
    active:border-forms-fill-focused active:bg-forms-fill-focused active:border-halfpulse
    has-[:focus]:ring-forms-border-filled has-[:focus]:bg-forms-fill-focused has-[:focus]:border-halfpulse
    has-[:active]:ring-forms-border-focused has-[:active]:bg-forms-fill-focused has-[:active]:border-halfpulse
    focus-within:ring-action-border-focused
    [&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill
    [&:not(:focus-within)]:has-[:not(:placeholder-shown)]:border-forms-border-filled
    has-[:active]:[&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill-focused
    has-[:active]:[&:not(:focus-within)]:has-[:placeholder-shown]:border-forms-border-focused
    has-[:active]:[&:not(:focus-within)]:has-[:not(:placeholder-shown)]:border-forms-border-focused
    has-[:focus]:has-[:not(:placeholder-shown)]:border-forms-border-focused
  `,
  variants: {
    size: {
      md: 'h-medium',
      ml: 'h-mediumlarge',
      lg: 'h-large',
    },
    hasFilled: {
      true: `
        border-forms-border-filled border-quarterpulse bg-forms-fill-filled
        active:border-forms-fill-focused active:bg-forms-fill-focused active:border-halfpulse
        hover:bg-forms-fill-filled hover:border-forms-border-filled hover:border-halfpulse
        has-[:active]:border-forms-fill-focused has-[:active]:bg-forms-fill-focused has-[:active]:border-halfpulse
        [&:not(:focus-within)]:has-[:placeholder-shown]:bg-forms-fill
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:bg-forms-fill-hovered
        [&:not(:focus-within)]:has-[:placeholder-shown]:ring-forms-border
        [&:not(:focus-within)]:has-[:placeholder-shown]:hover:ring-forms-border-hovered
        [&:not(:focus-within)]:has-[:placeholder-shown]:ring-none
    `,
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const SearchBarInput = tv({
  base: `
    peer/field font-wheight-regular text-text-neutral-alternative font-rdmodern font-regular text-threeandhalfpulse leading-none border-none bg-[transparent]
    flex-1 align-middle self-center focus-visible:border-none focus-visible:outline-none placeholder:text-text-neutral-alternative
    active:placeholder:text-text-neutral-placeholder focus:placeholder:text-text-neutral-placeholder
    active:text-text-neutral-placeholder focus:text-text-neutral
  `,
  variants: {
    size: {
      md: 'h-extrasmall',
      ml: 'h-extrasmall',
      lg: 'h-extrasmall',
    },
    hasFilled: {
      true: `text-text-neutral-alternative active:text-text-neutral
    `,
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const SearchBarButton = tv({
  base: 'searchbar-button bg-none',
  variants: {
    size: {
      md: 'h-medium w-medium min-w-medium',
      ml: 'h-mediumlarge w-mediumlarge min-w-mediumlarge',
      lg: 'h-mediumlarge w-mediumlarge min-w-mediumlarge',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export const SearchBarClear = tv({
  base: `
      searchbar-clear-button hidden
      peer-focus/field:peer-[:not(:placeholder-shown)]/field:flex peer-focus/field:peer-[:not(:placeholder-shown)]/field:visible
      group-hover:peer-[:not(:placeholder-shown)]/field:flex
    `,
  variants: {
    size: {
      md: 'h-medium w-medium min-w-medium',
      ml: 'h-mediumlarge w-mediumlarge min-w-mediumlarge',
      lg: 'h-mediumlarge w-mediumlarge min-w-mediumlarge',
    },
  },
})
